import SelectorEngine from '../../utils/dom/selector-engine';

class AccountDetailsCards {
	constructor() {
		this._wrapper = undefined;

		this.initiateCardDetail();
	}

	initiateCardDetail() {
		this._wrapper = SelectorEngine.findOne('.p-account-details__bank-details');

		if (this._wrapper) {
			const backButtons = SelectorEngine.find('.js-account-edit-back');
			if (backButtons.length > 0) {
				backButtons.forEach((backButton) => {
					backButton.addEventListener('click', (event) => {
						const rootUrl = window.location.origin
						const url = event.currentTarget.dataset.target;
						window.location.href = `${rootUrl}${url}`;
					});
				});
			}
		}
	}
};

const globalAccountDetailsCards = new AccountDetailsCards();

export default globalAccountDetailsCards;
